import { Box, Flex, HStack, Spinner, Stack } from '@chakra-ui/react';
import Chart from 'react-google-charts';
import React from 'react';
import { Heading } from '~/components';
import {
  useBarChartEquipmentConcorrentes,
  useBarChartEquipmentPositivo,
  useDonutChartEquipmentCompeting,
  useDonutChartEquipmentPositivoAndCompeting,
  usePieChartEquipmentGeral,
} from '~/hooks/useStrategicMap';
import { Card } from '~/components/Card';
import { SelectItem } from '~/types';

export const MachinePark: React.VFC<{
  grupoeconomico: SelectItem | undefined;
}> = ({ grupoeconomico }) => {
  const {
    data: pieChart,
    isLoading: isLoadingPiechart,
    isError: isErrorPiechart,
    isFetching: isFetchingPiechart,
  } = usePieChartEquipmentGeral(Number(grupoeconomico?.value));
  const {
    data: donutChart,
    isLoading: isLoadingDonutChart,
    isError: isErrorDonutChart,
    isFetching: isFetchingDonutChart,
  } = useDonutChartEquipmentCompeting(Number(grupoeconomico?.value));
  const {
    data: donutChartPositivoVsCompeting,
    isLoading: isLoadingDonutChartPositivoVsCompeting,
    isError: isErrorDonutChartPositivoVsCompeting,
    isFetching: isFetchingDonutChartPositivoVsCompeting,
  } = useDonutChartEquipmentPositivoAndCompeting(Number(grupoeconomico?.value));
  const {
    data: barChartPositivo,
    isLoading: isLoadingBarChartPositivo,
    isError: isErrorBarChartPositivo,
    isFetching: isFetchingBarChartPositivo,
  } = useBarChartEquipmentPositivo(Number(grupoeconomico?.value));
  const {
    data: barChartConcorrentes,
    isLoading: isLoadingBarChartConcorrentes,
    isError: isErrorBarChartConcorrentes,
    isFetching: isFetchingBarChartConcorrentes,
  } = useBarChartEquipmentConcorrentes(Number(grupoeconomico?.value));

  return (
    <>
      <HStack gridGap={3} flexWrap="wrap">
        <Card
          flexGrow={1}
          minHeight="392px"
          minW="32%"
          width="fit-content"
          bg="transparent"
          header={
            <Heading fontSize="16px">Equipamentos Geral Positivo</Heading>
          }
          content={
            <Flex p={0} justify="center" pb="30px">
              <Box placement="right" justify="right" ps={0}>
                <Stack gridGap={3} placement="right" justify="right">
                  {!isLoadingPiechart && !!grupoeconomico ? (
                    <Flex gridGap={2} justifyContent="center">
                      {pieChart && pieChart?.length > 1 ? (
                        <Chart
                          width="440px"
                          height="300px"
                          chartType="PieChart"
                          data={pieChart}
                          options={{
                            pieSliceText: 'value',
                            pieSliceTextStyle: {
                              color: 'black',
                            },
                            legend: { position: 'labeled' },
                            chartArea: {
                              left: 10,
                              top: 20,
                              bottom: 10,
                              width: '95%',
                              height: '100%',
                            },
                            noDataPattern: {
                              backgroundColor: 'transparent',
                              color: '#000',
                              label: 'Não há dados a serem apresentados',
                            },
                            colors: [
                              '#80c1e5',
                              '#f3af6a',
                              '#66c1b0',
                              '#a17bc6',
                              '#f293a1',
                              '#48CAE4',
                              '#DA3BAD',
                              '#FF8C05',
                              '#81C56A',
                              '#3071EF',
                              '#ff0000',
                            ],
                          }}
                          formatters={[
                            {
                              type: 'NumberFormat',
                              column: 1,
                              options: {
                                decimalSymbol: ',',
                                groupingSymbol: '.',
                                fractionDigits: 0,
                              },
                            },
                          ]}
                        />
                      ) : (
                        <Heading fontSize="16px">
                          Não há dados a serem apresentados
                        </Heading>
                      )}
                    </Flex>
                  ) : (
                    <Spinner style={{ marginLeft: '10px' }} />
                  )}
                </Stack>
              </Box>
            </Flex>
          }
        />
        <Card
          flexGrow={1}
          minHeight="392px"
          minW="32%"
          width="fit-content"
          bg="transparent"
          header={
            <Heading fontSize="16px">
              Tipos de Equipamentos dos Concorrentes
            </Heading>
          }
          content={
            <Flex p={0} justify="center" pb="30px">
              <Box placement="right" justify="right" ps={0}>
                <Stack gridGap={3} placement="right" justify="right">
                  {!isLoadingDonutChart && !!grupoeconomico ? (
                    <Flex gridGap={2} justifyContent="center">
                      {donutChart && donutChart.length > 1 ? (
                        <Chart
                          width="440px"
                          height="300px"
                          chartType="PieChart"
                          data={donutChart}
                          options={{
                            pieSliceText: 'value',
                            pieHole: 0.6,
                            pieSliceTextStyle: {
                              color: 'black',
                            },
                            legend: { position: 'labeled' },
                            chartArea: {
                              left: 10,
                              top: 20,
                              bottom: 10,
                              width: '95%',
                              height: '100%',
                            },
                            colors: [
                              '#0092CA',
                              '#FFB638',
                              '#04536C',
                              '#05A19C',
                              '#F677F7',
                              '#08D9D6',
                              '#FF2E63',
                              '#FCFF89',
                              '#0B409C',
                              '#ABCD9E',
                            ],
                          }}
                          formatters={[
                            {
                              type: 'NumberFormat',
                              column: 1,
                              options: {
                                decimalSymbol: ',',
                                groupingSymbol: '.',
                                fractionDigits: 0,
                              },
                            },
                          ]}
                        />
                      ) : (
                        <Heading fontSize="16px">
                          Não há dados a serem apresentados
                        </Heading>
                      )}
                    </Flex>
                  ) : (
                    <Spinner style={{ marginLeft: '10px' }} />
                  )}
                </Stack>
              </Box>
            </Flex>
          }
        />
        <Card
          flexGrow={1}
          minHeight="392px"
          minW="32%"
          width="fit-content"
          bg="transparent"
          header={
            <Heading fontSize="16px">
              Equipamentos Positivo e Concorrentes
            </Heading>
          }
          content={
            <Flex p={0} justify="center" pb="30px">
              <Box placement="right" justify="right" ps={0}>
                <Stack gridGap={3} placement="right" justify="right">
                  {!isLoadingDonutChartPositivoVsCompeting &&
                  !!grupoeconomico ? (
                    <Flex gridGap={2} justifyContent="center">
                      {donutChartPositivoVsCompeting &&
                      donutChartPositivoVsCompeting.length > 1 ? (
                        <Chart
                          width="440px"
                          height="300px"
                          chartType="PieChart"
                          data={donutChartPositivoVsCompeting}
                          options={{
                            pieSliceText: 'value',
                            pieSliceTextStyle: {
                              color: 'black',
                            },
                            pieHole: 0.6,
                            legend: { position: 'labeled' },
                            chartArea: {
                              left: 10,
                              top: 20,
                              bottom: 10,
                              width: '95%',
                              height: '100%',
                            },
                            colors: [
                              '#877CFF',
                              '#57D131',
                              '#FF6600',
                              '#24AC78',
                              '#1E549F',
                              '#26BAEE',
                              '#FF8364',
                              '#A9C52F',
                              '#5170FD',
                              '#BC1F45',
                              '#63E37F',
                            ],
                            pieStartAngle: 75,
                          }}
                          formatters={[
                            {
                              type: 'NumberFormat',
                              column: 1,
                              options: {
                                decimalSymbol: ',',
                                groupingSymbol: '.',
                                fractionDigits: 0,
                              },
                            },
                          ]}
                        />
                      ) : (
                        <Heading fontSize="16px">
                          Não há dados a serem apresentados
                        </Heading>
                      )}
                    </Flex>
                  ) : (
                    <Spinner style={{ marginLeft: '10px' }} />
                  )}
                </Stack>
              </Box>
            </Flex>
          }
        />
      </HStack>
      <HStack gridGap={3} flexWrap="wrap" mt={5}>
        <Card
          flexGrow={1}
          minHeight="492px"
          minW="45%"
          width="fit-content"
          bg="transparent"
          header={
            <Heading fontSize="16px">Idade Equipamentos Positivo</Heading>
          }
          content={
            <Flex p={0} justify="center" pb="30px">
              <Box placement="right" justify="right" ps={0}>
                <Stack gridGap={3} placement="right" justify="right">
                  {!isLoadingBarChartPositivo && !!grupoeconomico ? (
                    <Flex gridGap={2} justifyContent="center">
                      {barChartPositivo && barChartPositivo.length > 1 ? (
                        <Chart
                          key={JSON.stringify(barChartPositivo)}
                          width="650px"
                          height="400px"
                          chartType="ColumnChart"
                          data={barChartPositivo}
                          chartLanguage="pt-BR"
                          options={{
                            legend: { position: 'top' },
                            chartArea: {
                              left: 50,
                              top: 20,
                              bottom: 50,
                              width: '95%',
                              height: '70%',
                            },
                            hAxis: {
                              title: 'Tipos',
                              minValue: 0,
                              textStyle: {
                                fontSize: 12,
                              },
                            },
                            vAxis: {
                              title: 'Quantidade',
                              textStyle: {
                                fontSize: 12,
                                color: '#000000',
                              },
                              minValue: 0,
                              format: '####',
                            },
                            colors: [
                              '#774AF0',
                              '#FF008E',
                              '#FF4662',
                              '#E25500',
                              '#2E99B0',
                              '#C4F951',
                            ],
                            bar: { groupWidth: '95%' },
                            annotations: {
                              textStyle: {
                                fontSize: 12,
                                color: '#000',
                                auraColor: 'none',
                              },
                            },
                            tooltip: { isHtml: true },
                          }}
                          formatters={[
                            {
                              type: 'NumberFormat',
                              column: 1,
                              options: {
                                decimalSymbol: ',',
                                groupingSymbol: '.',
                                fractionDigits: 0,
                              },
                            },
                          ]}
                        />
                      ) : (
                        <Heading fontSize="16px">
                          Não há dados a serem apresentados
                        </Heading>
                      )}
                    </Flex>
                  ) : (
                    <Spinner style={{ marginLeft: '10px' }} />
                  )}
                </Stack>
              </Box>
            </Flex>
          }
        />
        <Card
          flexGrow={1}
          minHeight="492px"
          minW="49%"
          width="fit-content"
          bg="transparent"
          header={
            <Heading fontSize="16px">Idade Equipamentos Concorrentes</Heading>
          }
          content={
            <Flex p={0} justify="center" pb="30px">
              <Box placement="right" justify="right" ps={0}>
                <Stack gridGap={3} placement="right" justify="right">
                  {!isLoadingBarChartConcorrentes && !!grupoeconomico ? (
                    <Flex gridGap={2} justifyContent="center">
                      {barChartConcorrentes &&
                      barChartConcorrentes.length > 1 ? (
                        <Chart
                          key={JSON.stringify(barChartConcorrentes)}
                          width="800px"
                          height="400px"
                          chartType="ColumnChart"
                          data={barChartConcorrentes}
                          chartLanguage="pt-BR"
                          options={{
                            legend: { position: 'top', margin: '10px' },
                            chartArea: {
                              left: 50,
                              top: 20,
                              bottom: 50,
                              width: '95%',
                              height: '70%',
                            },
                            hAxis: {
                              title: 'Tipos',
                              minValue: 0,
                              textStyle: {
                                fontSize: 12,
                              },
                            },
                            vAxis: {
                              title: 'Quantidade',
                              textStyle: {
                                fontSize: 12,
                                color: '#000000',
                              },
                              minValue: 0,
                              format: '####',
                            },
                            colors: [
                              '#009D23',
                              '#0C2572',
                              '#991F65',
                              '#CC233E',
                              '#93A2F6',
                              '#B0AB21',
                              '#2C47DE',
                            ],
                            bar: { groupWidth: '95%' },
                            annotations: {
                              textStyle: {
                                fontSize: 12,
                                color: '#000',
                                auraColor: 'none',
                              },
                            },
                            tooltip: { isHtml: true },
                          }}
                          formatters={[
                            {
                              type: 'NumberFormat',
                              column: 1,
                              options: {
                                decimalSymbol: ',',
                                groupingSymbol: '.',
                                fractionDigits: 0,
                                locale: 'pt-BR',
                              },
                            },
                          ]}
                        />
                      ) : (
                        <Heading fontSize="16px">
                          Não há dados a serem apresentados
                        </Heading>
                      )}
                    </Flex>
                  ) : (
                    <Spinner style={{ marginLeft: '10px' }} />
                  )}
                </Stack>
              </Box>
            </Flex>
          }
        />
      </HStack>
    </>
  );
};
